<style lang="scss" scoped src="./style.scss" />
<script lang="ts" src="./script.ts" />

<template>
    <img v-if="logo" :src="logo" alt="logo" height="32" />
</template>
